/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Wechat_TitleInputs */

const en_admin_settings_groups_wechat_title = /** @type {(inputs: Admin_Settings_Groups_Wechat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WeChat Pay`)
};

/**
* | output |
* | --- |
* | "WeChat Pay" |
*
* @param {Admin_Settings_Groups_Wechat_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_wechat_title = /** @type {((inputs?: Admin_Settings_Groups_Wechat_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Wechat_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_wechat_title(inputs)
});
export { admin_settings_groups_wechat_title as "admin.settings.groups.wechat.title" }